import PlateDetailCard from './PlateDetailCard';

export default PlateDetailCard;
